import { render, staticRenderFns } from "./ReferrerLayout.vue?vue&type=template&id=c074d096&"
import script from "./ReferrerLayout.vue?vue&type=script&lang=js&"
export * from "./ReferrerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports